import Vue from 'vue';
import Router from 'vue-router';
import Meta from 'vue-meta';
import store from '../stores/index';

import Home from '../pages/home/Home';
import Step3 from '../pages/tunnel/step3';
import Step4 from '../pages/tunnel/step4-multi';
import Step5 from '../pages/tunnel/step5';
import Room from "../pages/rooms/Room";
import Profile from '../pages/client/profile'
import SetNewPassword from '../pages/client/set-new-password';
import Register from '../pages/client/register';
import Concept from '../pages/concept/concept';
import Extras from '../pages/extras/extras';
import p404 from '../pages/404';
import paymentRedirect from "../pages/payment-redirect";
import Pro from '../pages/invest-pro/pro';
import Invest from '../pages/invest-pro/invest';
import Privacy from '../pages/client/privacy';
import Search from '../pages/search/search';
import Store from '../stores/index.js';
import FAQ from '../pages/faq/faq';
import {guards} from "./guards/multi-gaurds.guard";
import {requireAuth} from "./guards/require-auth.guard";
import {requireSC} from "./guards/require-shopping-cart.guard";
import RoutePersonalData from "../pages/client/route-personal-data"
import RouteMyProfile from "../pages/client/route-my-account"

Vue.use(Router);
Vue.use(Meta);

const routes = {
    fr: {
        home: {path: '/accueil', meta: null},
        paymentRedirect: {path: '/test-appli',meta:null},
        homeCgv: {path: '/cgv', meta: null},
        homeLegalNotice: {path: '/mentions-legales', meta: null},
        places: {path: '/etape-1/choisissez-votre-endroit', meta: null},
        rooms: {path: '/etape-2/choisissez-votre-suite/:roomGroup?', meta: null},
        step3: {path: '/etape-3/vos-extras/:shoppingCart/:shoppingBookingId', meta: null},
        step4: {path: '/etape-4/votre-reservation', meta: null},
        step5: {path: '/etape-5/confirmation-de-reservation', meta: null},
        roomDetail: {path: '/Suite/:id(\\d+)', meta: null},
        room: {path: '/Suite/:id(\\d+)-:slug', meta: null},
        profile: {
            path: '/mon-compte',
            meta: null,
            children: [
                {
                    path: '/mon-compte',
                    name: 'profile',
                    meta: null,
                    component: RouteMyProfile
                },
                {
                    path: '/mon-compte/donnees-personnelles',
                    meta: null,
                    name: 'profile-data',
                    component: RoutePersonalData
                }
            ]
        },
        register: {path: '/creer-un-compte', meta: null},
        concept: {path: '/le-concept/:conceptMenuId', meta: null},
        concept2: {path: '/le-concept/:conceptMenuId-:slug', meta: null},
        extras: {path: '/les-extras', meta: null},
        search: {path: '/Suites', meta: null},
        p404: {path: '/404-page-non-trouvee', meta: null},
        pro: {path: '/serial-voyageur', meta: null},
        invest: {path: '/investir-dans-mihotel', meta: null},
        privacy: {path: '/espace-rgpd', meta: null},
        setNewPassword: {path: '/mon-compte/reinitialiser-mon-mot-de-passe', meta: null},
        faq: {path: '/les-questions-frequentes', meta: null}
    },
    en: {
        home: {path: '/home', meta: null},
        homeCgv: {path: '/cgv', meta: null},
        homeLegalNotice: {path: '/mentions-legales', meta: null},
        search: {path: '/Suites', meta: null},
        places: {path: '/step-1/choose-your-zone', meta: null},
        rooms: {path: '/step-2/choose-your-room/:roomGroup?', meta: null},
        step3: {path: '/step-3/extras/:shoppingCart/:shoppingBookingId', meta: null},
        step4: {path: '/step-4/your-booking', meta: null},
        step5: {path: '/step-5/booking-confirmation', meta: null},
        roomDetail: {path: '/Suite/:id(\\d+)', meta: null},
        room: {path: '/Suite/:id(\\d+)-:slug', meta: null},
        profile: {
            path: '/my-account',
            meta: null,
            children: [
                {
                    path: '/my-account',
                    name: 'profile',
                    meta: null,
                    component: RouteMyProfile
                },
                {
                    path: '/my-account/personal-data',
                    meta: null,
                    name: 'profile-data',
                    component: RoutePersonalData
                }
            ]
        },
        register: {path: '/create-an-account', meta: null},
        concept: {path: '/concept/:conceptMenuId', meta: null},
        concept2: {path: '/concept/:conceptMenuId-:slug', meta: null},
        extras: {path: '/extras', meta: null},
        p404: {path: '/404-not-found', meta: null},
        pro: {path: '/serial-traveler', meta: null},
        invest: {path: '/invest-in-mihotel', meta: null},
        privacy: {path: '/gdpr', meta: null},
        setNewPassword: {path: '/my-account/reset-password', meta: null},
        faq: {path: '/frequently-asked-questions', meta: null}
    }
}


function getRoutes(lang) {
    lang = lang.toLowerCase();
    return [
        {
            path: routes[lang].homeCgv.path,
            meta: routes[lang].homeCgv.meta,
            name: 'homeCgv',
            component: Home
        },
        {
            path: routes[lang].homeLegalNotice.path,
            meta: routes[lang].homeLegalNotice.meta,
            name: 'homeLegalNotice',
            component: Home
        },
        {
            path: routes[lang].home.path,
            meta: routes[lang].home.meta,
            name: 'home',
            component: Home,
        },
        {
            path: routes[lang].search.path,
            meta: routes[lang].search.meta,
            name: 'search',
            component: Search
        },
        {
            path: routes[lang].places.path,
            meta: routes[lang].places.meta,
            name: 'places',
            redirect: routes[lang].search,
            // component: Step1,
        },
        {
            path: routes[lang].rooms.path,
            meta: routes[lang].rooms.meta,
            name: 'rooms',
            redirect: routes[lang].search,
            // component: Step2,
        },
        {
            path: routes[lang].step3.path,
            meta: routes[lang].step3.meta,
            name: 'step3',
            component: Step3,
            beforeEnter: requireSC,
        },
        {
            path: routes[lang].step4.path,
            meta: routes[lang].step4.meta,
            name: 'step4',
            component: Step4,
            beforeEnter: guards(requireSC, requireAuth),
        },
        {
            path: routes[lang].step5.path,
            meta: routes[lang].step5.meta,
            name: 'step5',
            component: Step5
        },
        {
            path: routes[lang].roomDetail.path,
            meta: routes[lang].roomDetail.meta,
            component: Room,
            name: 'roomDetail',
        },
        {
            path: routes[lang].room.path,
            meta: routes[lang].room.meta,
            component: Room,
            name: 'room'
        },
        {
            path: '/',
            redirect: routes[lang].home,
        },
        {
            path: '/checkout/process',
            redirect: routes[lang].step5,
        },
        {
            path: routes[lang].setNewPassword.path,
            meta: routes[lang].setNewPassword.meta,
            component: SetNewPassword,
            name: 'setNewPassword'
        },
        {
            path: routes[lang].profile.path,
            meta: routes[lang].profile.meta,
            name: 'profile-router',
            component: Profile,
            beforeEnter: requireAuth,
            children: routes[lang].profile.children
        },
        {
            path: routes[lang].register.path,
            meta: routes[lang].register.meta,
            name: 'register',
            component: Register,
        },
        {
            path: routes[lang].concept.path,
            meta: routes[lang].concept.meta,
            name: 'concept',
            component: Concept,
        },
        {
            path: routes[lang].concept2.path,
            meta: routes[lang].concept2.meta,
            name: 'concept2',
            component: Concept,
        },
        {
            path: routes[lang].extras.path,
            meta: routes[lang].extras.meta,
            name: 'extras',
            component: Extras
        },
        {
            path: routes[lang].p404.path,
            meta: routes[lang].p404.meta,
            name: '404',
            component: p404
        },
        {
            path: routes[lang].pro.path,
            meta: routes[lang].pro.meta,
            name: 'pro',
            component: Pro
        },
        {
            path: routes[lang].invest.path,
            meta: routes[lang].invest.meta,
            name: 'invest',
            component: Invest
        },
        {
            path: routes[lang].privacy.path,
            meta: routes[lang].privacy.meta,
            name: 'privacy',
            component: Privacy
        },
        {
            path: routes[lang].faq.path,
            meta: routes[lang].faq.meta,
            name: 'faq',
            component: FAQ
        },
      {
        path: routes[lang].paymentRedirect.path,
        meta: routes[lang].paymentRedirect.meta,
        name: 'paymentRedirect',
        component: paymentRedirect
      },
        {
            path: '/appartments',
            redirect: {name: 'rooms'}
        },
        {
            path: '/concept',
            redirect: {name: 'concept2', params: {conceptMenuId: 1, slug: 'le-concept'}}
        },
        {
            path: '/services',
            redirect: {name: 'extras'}
        },
        {
            path: '/reset-password',
            redirect: {name: 'setNewPassword'}
        },
        {
            path: '/trouver-ma-suite',
            redirect: routes[lang].search
        },
        {
            path: '/find-my-suite',
            redirect: routes[lang].search
        },
      {
        path: '/test-appli',
        redirect: {name: 'paymentRedirect'}
      },
        {
            path: '*',
            redirect: {name: '404'}
        }
    ];
}

store.watch((state, getters) => state.lang.currentLang, () => {
    const currentRoute = router.currentRoute;
    const newRouter = new Router({
        mode: 'history',
        routes: getRoutes(store.state.lang.currentLang),
        scrollBehavior(to, from, savedPosition) {
            return {x: 0, y: 0};
        },
    })
    const route = newRouter.match({name: currentRoute.name, params: currentRoute.params, query: currentRoute.query});
    router.matcher = newRouter.matcher;
    if (currentRoute.fullPath !== route.fullPath) {
        router.push({name: currentRoute.name, params: currentRoute.params, query: currentRoute.query});
    }

});

const router = new Router({
    mode: 'history',
    routes: getRoutes(store.state.lang.currentLang),
    scrollBehavior(to, from, savedPosition) {
        return {x: 0, y: 0};
    },
});

// router.beforeEach((to, from, next) => {
//     next();
// })

router.beforeEach((to, from, next) => {
    if (to.matched.length === 0) {
        next({name: '404'});
        return;
    }
    Store.commit('mobileMenu/CLOSE');
    next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js